import { ChainId, Token } from 'vvs-sdk'
import { serializeToken } from 'state/user/hooks/helpers'
import { SerializedToken } from './types'

const { MAINNET, TESTNET } = ChainId

interface TokenList {
  [symbol: string]: Token
}

interface SerializedTokenList {
  [symbol: string]: SerializedToken
}

export const mainnetTokens = {
  workbench: new Token(
    MAINNET,
    process.env.REACT_APP_WORKBENCH_ADDRESS_MAINNET,
    18,
    'WORKBENCH',
    'WORKBENCH',
    'https://vvs.finance/',
  ),
  cro: new Token(MAINNET, '0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23', 18, 'CRO', 'CRO Token', 'https://crypto.org/'),
  wcro: new Token(
    MAINNET,
    '0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23',
    18,
    'WCRO',
    'Wrapped CRO',
    'https://crypto.org/',
  ),
  vvs: new Token(MAINNET, '0x2D03bECE6747ADC00E1a131BBA1469C15fD11e03', 18, 'VVS', 'VVS', 'https://vvs.finance/'),
  eth: new Token(
    MAINNET,
    '0xe44Fd7fCb2b1581822D0c862B68222998a0c299a',
    18,
    'ETH',
    'Wrapped Ether',
    'https://ethereum.org/en/',
  ),
  weth: new Token(
    MAINNET,
    '0xe44Fd7fCb2b1581822D0c862B68222998a0c299a',
    18,
    'WETH',
    'Wrapped Ether',
    'https://ethereum.org/en/',
  ),
  usdc: new Token(
    MAINNET,
    '0xc21223249CA28397B4B6541dfFaEcC539BfF0c59',
    6,
    'USDC',
    'USD Coin',
    'https://www.circle.com/en/usdc',
  ),
  wbtc: new Token(
    MAINNET,
    '0x062E66477Faf219F25D27dCED647BF57C3107d52',
    8,
    'WBTC',
    'Wrapped BTC',
    'https://bitcoin.org/en/',
  ),
  usdt: new Token(MAINNET, '0x66e428c3f67a68878562e79A0234c1F83c208770', 6, 'USDT', 'Tether USD', 'https://tether.to/'),
  shib: new Token(
    MAINNET,
    '0xbED48612BC69fA1CaB67052b42a95FB30C1bcFee',
    18,
    'SHIB',
    'Shiba Inu',
    'https://shibatoken.com/',
  ),
  bifi: new Token(
    MAINNET,
    '0xe6801928061CDbE32AC5AD0634427E140EFd05F9',
    18,
    'BIFI',
    'Beefy.finance',
    'https://www.beefy.finance/',
  ),
  dai: new Token(
    MAINNET,
    '0xF2001B145b43032AAF5Ee2884e456CCd805F677D',
    18,
    'DAI',
    'Dai Stablecoin',
    'https://makerdao.com/',
  ),
  doge: new Token(MAINNET, '0x1a8E39ae59e5556B56b76fCBA98d22c9ae557396', 8, 'DOGE', 'Dogecoin', 'http://dogecoin.com/'),
  atom: new Token(MAINNET, '0xB888d8Dd1733d72681b30c00ee76BDE93ae7aa93', 6, 'ATOM', 'ATOM', 'http://cosmos.network/'),
  tonic: new Token(
    MAINNET,
    '0xDD73dEa10ABC2Bff99c60882EC5b2B81Bb1Dc5B2',
    18,
    'TONIC',
    'Tectonic',
    'https://tectonic.finance/',
  ),
  link: new Token(
    MAINNET,
    '0xBc6f24649CCd67eC42342AccdCECCB2eFA27c9d9',
    18,
    'LINK',
    'Chainlink',
    'https://chain.link/',
  ),
  enj: new Token(MAINNET, '0x0A92ea8a197919aCb9BC26660Ed0D43D01ed26b7', 18, 'ENJ', 'Enjin', 'https://enjin.io/'),
  elon: new Token(
    MAINNET,
    '0x02DCcaf514C98451320a9365C5b46C61d3246ff3',
    18,
    'ELON',
    'Dogelon Mars',
    'https://dogelonmars.com/',
  ),
  single: new Token(
    MAINNET,
    '0x0804702a4E749d39A35FDe73d1DF0B1f1D6b8347',
    18,
    'SINGLE',
    'SINGLE Token',
    'https://singlefinance.io/',
  ),
  luna: new Token(MAINNET, '0x9278C8693e7328bef49804BacbFb63253565dffD', 6, 'LUNA', 'LUNA', 'https://www.terra.money/'),
}

// FIXME tokens for testnet and mainnet
export const testnetTokens = {
  workbench: new Token(
    TESTNET,
    process.env.REACT_APP_WORKBENCH_ADDRESS_TESTNET,
    18,
    'WORKBENCH',
    'WORKBENCH',
    'https://vvs.finance/',
  ),
  cro: new Token(TESTNET, '0x6a3173618859C7cd40fAF6921b5E9eB6A76f1fD4', 18, 'CRO', 'CRO', 'https://crypto.org/'),
  wcro: new Token(
    TESTNET,
    '0x6a3173618859C7cd40fAF6921b5E9eB6A76f1fD4',
    18,
    'WCRO',
    'Wrapped CRO',
    'https://crypto.org/',
  ),
  vvs: new Token(TESTNET, '0x904Bd5a5AAC0B9d88A0D47864724218986Ad4a3a', 18, 'VVS', 'VVS', 'https://vvs.finance/'),
  eth: new Token(
    TESTNET,
    '0x441d72d584b16105FF1C68DC8bc4517F4DC13E55',
    18,
    'ETH',
    'Wrapped Ether',
    'https://ethereum.org/en/',
  ),
  weth: new Token(
    TESTNET,
    '0x441d72d584b16105FF1C68DC8bc4517F4DC13E55',
    18,
    'WETH',
    'Wrapped Ether',
    'https://ethereum.org/en/',
  ),
  usdc: new Token(
    TESTNET,
    '0x321106E51b78E0E9CEBcFeC63C5250F0F3CcB82b',
    6,
    'USDC',
    'USD Coin',
    'https://www.circle.com/en/usdc',
  ),
  wbtc: new Token(
    TESTNET,
    '0xFFc8ce84a196420d7bCCDEe980c65364eD1f389F',
    18,
    'WBTC',
    'Wrapped BTC',
    'https://bitcoin.org/en/',
  ),
  usdt: new Token(TESTNET, '0x914a8825B29a04ae687625eCDa20B67abd0B58b1', 6, 'USDT', 'Tether USD', 'https://tether.to/'),
  shib: new Token(
    TESTNET,
    '0xF6dF880DF3571ab39a3E09a74D8DB00107e9A43E',
    18,
    'SHIB',
    'Shiba Inu',
    'https://shibatoken.com/',
  ),
  coffee: new Token(
    TESTNET,
    '0x2DA12B663DAAbB01319c75F4ACC121618bA7785C',
    18,
    'COFFEE',
    'Coffee',
    'https://vvs.finance/',
  ),
  fish_ball: new Token(
    TESTNET,
    '0xc7cB072748dd938c1014c4253Ba72a806c35B363',
    18,
    'FISH_BALL',
    'Fish Ball',
    'https://vvs.finance/',
  ),
  rich_man: new Token(
    TESTNET,
    '0xBA9753472180A44bdB6045a2DAbBb2f63f7B7E95',
    18,
    'RICH_MAN',
    'Rich Man',
    'https://vvs.finance/',
  ),
  poor_man: new Token(
    TESTNET,
    '0xf21D12f075ee0FCC6931d660EbD5a65abd9a354B',
    18,
    'POOR_MAN',
    'Pool Man',
    'https://vvs.finance/',
  ),
  banana: new Token(
    TESTNET,
    '0x75a98c7ED2D451557D6E22F7f75958DA43E0F143',
    18,
    'BANANA',
    'Banana',
    'https://vvs.finance/',
  ),
  orange: new Token(
    TESTNET,
    '0xb7189faaaa0cd9a6d006a454b527a54f97e3f5d8',
    18,
    'ORANGE',
    'Orange',
    'https://vvs.finance/',
  ),
  salad: new Token(TESTNET, '0x755979387ecDF3d26145C2E9d0BBC9c008409c35', 18, 'SALAD', 'Salad', 'https://vvs.finance/'),
  hamburger: new Token(
    TESTNET,
    '0x35f38e0eAb6A9d4EE28956665b20B133955887b6',
    18,
    'HAMBURGER',
    'Hamburger',
    'https://vvs.finance/',
  ),
  pizza: new Token(TESTNET, '0x5da960c75BD0FeC0eEaf3dc13f92279161b694F4', 18, 'PIZZA', 'Pizza', 'https://vvs.finance/'),
  muffin: new Token(
    TESTNET,
    '0xeCEd065C7AeAA2daff3199ead1544511b2612022',
    18,
    'MUFFIN',
    'Muffin',
    'https://vvs.finance/',
  ),
  ginger: new Token(
    TESTNET,
    '0x67Bc49E7392d5467d758A4fcCA2b0246a4218F25',
    18,
    'GINGER',
    'Ginger',
    'https://vvs.finance/',
  ),
  seattle: new Token(
    TESTNET,
    '0x44B23563FCe03deeaA4e19270Fdb645a8017F260',
    18,
    'SEATTLE',
    'Seattle',
    'https://vvs.finance/',
  ),
  single: new Token(
    TESTNET,
    '0x0804702a4E749d39A35FDe73d1DF0B1f1D6b8347',
    18,
    'SINGLE',
    'SINGLE Token',
    'https://singlefinance.io/',
  ),
}

const tokens = (): TokenList => {
  const chainId = process.env.REACT_APP_CHAIN_ID

  // If testnet - return list comprised of testnetTokens wherever they exist, and mainnetTokens where they don't
  if (parseInt(chainId, 10) === ChainId.TESTNET) {
    // return Object.keys(mainnetTokens).reduce((accum, key) => {
    //   return { ...accum, [key]: testnetTokens[key] || mainnetTokens[key] }
    // }, {})
    return testnetTokens // FIXME avoid this mainnet override testnet hack
  }

  return mainnetTokens
}

export const serializeTokens = (): SerializedTokenList => {
  const unserializedTokens = tokens()
  const serializedTokens = Object.keys(unserializedTokens).reduce((accum, key) => {
    return { ...accum, [key]: serializeToken(unserializedTokens[key]) }
  }, {})

  return serializedTokens
}

export default tokens()
